import * as i18n from "../i18n.ts";

export function digit2(num :number){
  if(num<0) throw new Error('cannot digit2 '+num);
  if(num<10) return '0'+num;
  if(num<100) return num;
  throw new Error('cannot digit2 '+num);
}

export function digit3(num :number){
  if(num<0) throw new Error('cannot digit3 '+num);
  if(num<10) return '00'+num;
  if(num<100) return '0'+num;
  if(num<1000) return num;
  throw new Error('cannot digit3 '+num);
}

function digit4(num :number){
  if(num<0) throw new Error('cannot digit4 '+num);
  if(num<10) return '000'+num;
  if(num<100) return '00'+num;
  if(num<1000) return '0'+num;
  if(num<10000) return num;
  throw new Error('cannot digit4 '+num);
}
export function clearTime(date :Date){

  date = new Date(date.getTime())
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
}
export function forInputTime(date :Date){
  if(!date) return '';
  return digit2(date.getHours())+':'+digit2(date.getMinutes());
}
export function forInputDate(date :Date){
  if(!date) return '';
  return digit4(date.getFullYear())+'-'+digit2(date.getMonth()+1)+'-'+digit2(date.getDate());
}
export function forInputDateTimeLocal(date :Date){
  if(!date) return '';
  return digit4(date.getFullYear())+'-'+digit2(date.getMonth()+1)+'-'+digit2(date.getDate())+'T'+digit2(date.getHours())+':'+digit2(date.getMinutes());
}



export class DateRange{
  start :Date
  end :Date
  next ?:Date
  prev ?:Date
  recurrency ?:string //FIXME put all type here
  name: string
  days :number
  isPast :boolean
  isFuture :boolean
  containsToday : boolean

  constructor(options: { start: any; end: any; next?: any; prev?: any; recurrency: any; name?: any; days?: any; }){
    this.start = options.start;
    this.end = options.end;
    this.next = options.next;
    this.prev = options.prev;
    this.recurrency = options.recurrency;
    this.name = options.name;
    this.days = options.days;

    var now = new Date();
    this.isPast = (now>=this.end)
    this.isFuture = (now<this.start)
    this.containsToday = !(this.isPast || this.isFuture)

  }
  getDays(){
    if(!(this.start instanceof Date)) return [];
    if(!(this.end instanceof Date)) return [];
    var days = []
    for(var date = new Date(this.start);date<this.end;date.setDate(date.getDate()+1)){
      var
        day = {
          legend:date.getDate(),
          fulldayName : toLocaleString(date,{weekday: 'long', month: 'short', day: 'numeric' }).replace(/^.{1}/,function(firstChar){return firstChar.toUpperCase()}),
          date:new Date(date), //FIXME do not use date anymore but start and end
          start:new Date(date),
          end:new Date(date),
          key:forInputDate(date)
          };
      //compute end well
      day.end.setDate(day.end.getDate()+1)

      days.push(day)
    }
    return days;

  }
}

export function getRelativeDayToNextMonth(date :Date){
  if(date==null) return null;
  var
    crawlerToNextMonth = 0,
    crawler = new Date(date.getTime());
  while(crawler.getMonth()===date.getMonth()){
    crawlerToNextMonth--;
    crawler.setDate(crawler.getDate()+1)
  }
  return crawlerToNextMonth
}

export function getDayCountTo(to : Date, from = new Date()){
  var
    delta = (to.getTime() - from.getTime())/(3600000*24);
  return Math.max(0,Math.floor(delta))
}

export function getYearRange(date :Date){
  var
    next = new Date(date.getTime()),
    prev = new Date(date.getTime());
  next.setFullYear(next.getFullYear()+1);
  prev.setFullYear(prev.getFullYear()-1);
  return new DateRange({
    start:new Date(date.getFullYear(),0,1),
    end:new Date(date.getFullYear()+1,0,1),
    next:next,
    prev:prev,
    recurrency:"YEARLY",
    name:""+date.getFullYear(),
    days:date.getFullYear()%4===0?366:365
  })
}
export function getYearRangeFrom(date = new Date()){
  const
    start = clearTime(date),
    next = new Date(date.getTime()),
    prev = new Date(date.getTime());

  const end = new Date(start.getTime())
  end.setFullYear(end.getFullYear()+1);

  next.setFullYear(next.getFullYear()+1);
  prev.setFullYear(prev.getFullYear()-1);
  return new DateRange({
    start,
    end,
    next:next,
    prev:prev,
    recurrency:"YEARLY",
    name:""+date.getFullYear(),
    days:date.getFullYear()%4===0?366:365
  })
}

export function getMonthRange(date :Date = new Date()){
  var
    isCleanNav = date.getDate()<29,
    next = new Date(date.getTime()),
    prev = new Date(date.getTime());
  if(!isCleanNav){
    next.setDate(28);
    prev.setDate(28);
  }
  next.setMonth(next.getMonth()+1);
  prev.setMonth(prev.getMonth()-1);

  var end = new Date(next.getTime());

  return new DateRange({
    start:new Date(date.getFullYear(),date.getMonth(),1),
    end:new Date(end.getFullYear(),end.getMonth(),1),
    next:next,
    prev:prev,
    recurrency:"MONTHLY",
    name:format(date,'MMMM') + ' '+date.getFullYear(),
    days:[31,date.getFullYear()%4===0?29:28,31,30,31,30,31,31,30,31,30,31][date.getMonth()] //FIXME it depends of the month
  })
}

export function getWeekNumber(date :Date){
  var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  var dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1)/7)
}

export function getWeekRange(date :Date,firstDayOfWeek=0,interval=1){
  if(firstDayOfWeek==null){
    firstDayOfWeek = getFirstDayOfWeek()
  }
  var
    delta = interval*7,
    next = new Date(date.getTime()),
    prev = new Date(date.getTime()),
    seed = new Date('2018-01-01T00:00');

  seed.setDate(firstDayOfWeek);

  var end = new Date(seed.getTime());
  end.setDate(end.getDate()+delta);

  while(end<=date){
    seed.setDate(seed.getDate()+delta);
    end.setDate(end.getDate()+delta);
  }
  while(seed>date){
    seed.setDate(seed.getDate()-delta);
    end.setDate(end.getDate()-delta);
  }

  next.setDate(next.getDate()+delta);
  prev.setDate(prev.getDate()-delta);

  return new DateRange({
    start:seed,
    end:end,
    next:next,
    prev:prev,
    recurrency:"WEEKLY",
    name:dayRangeString(seed,new Date(end.getTime()-1000)),
    days:delta
  })
}
export function getFullRange(){
  return new DateRange({start:-Infinity,end:Infinity,recurrency:'NONE'})
}
export function getDayRange(date :Date){
  var
    next = dateAdd(date,{day:1}),
    prev = dateAdd(date,{day:-1}),
    start = clearTime(date),
    end = dateAdd(start,{day:1});

  return new DateRange({
    start:start,
    end:end,
    next:next,
    prev:prev,
    recurrency:"DAILY",
    name:format(date,"LL"),
    days:1
  })
}

export function getRangeUntil(date :Date){
  var
    start = -Infinity,
    end = new Date(date.getTime());

  return new DateRange({
    start:start,
    end:end,
    recurrency:"NONE",
    name:'Until '+format(date,"LL"), //TODO externalize the until, but name fo those range are not used for now
    days:Infinity
  })
}

export function getStartOfDay(date :Date){
  return clearTime(date);
}

export function getEndOfDay(date :Date){
  var end = clearTime(date);
  end.setDate(end.getDate()+1);
  return new Date(end.getTime()-1000);
}
export function dayRangeString(start :Date,end :Date){
  var optionsStart :Intl.DateTimeFormatOptions = {day:"numeric"}
  if(start.getFullYear()===end.getFullYear()){
    if(start.getMonth()!==end.getMonth()){
      optionsStart.month="short"
    }
  }else{
    optionsStart.month="short"
    //this one causes to big text for where we put it
    //optionsStart.year="numeric"
  }
  return toLocaleString(start, optionsStart) + ' - '+ toLocaleString(end, { day:"numeric",month:"short",year:"numeric"})
}

type dateModifyInput = {year?:number,month?:number,week?:number,day?:number,hour?:number,minute?:number,second?:number,milli?:number}

export function dateAdd(date : Date, modifiers : dateModifyInput){
  var result = new Date(date.getTime());
  if(modifiers.year !==undefined){
    result.setFullYear(result.getFullYear()+modifiers.year);
  }
  if(modifiers.month !==undefined){
    result.setMonth(result.getMonth()+modifiers.month);
  }
  if(modifiers.week !==undefined){
    result.setDate(result.getDate()+ 7*modifiers.week);
  }
  if(modifiers.day !==undefined){
    result.setDate(result.getDate()+ modifiers.day);
  }
  if(modifiers.hour !==undefined){
    result.setHours(result.getHours()+ modifiers.hour);
  }
  if(modifiers.minute !==undefined){
    result.setMinutes(result.getMinutes()+ modifiers.minute);
  }
  if(modifiers.second !==undefined){
    result.setSeconds(result.getSeconds()+ modifiers.second);
  }
  if(modifiers.milli !==undefined){
    result.setMilliseconds(result.getMilliseconds()+ modifiers.milli);
  }
  return result;
}

export function dateSet(date : Date, modifiers : dateModifyInput){
  var result = new Date(date.getTime());
  if(modifiers.year !==undefined){
    result.setFullYear(modifiers.year);
  }
  if(modifiers.month !==undefined){
    result.setMonth(modifiers.month);
  }
  if(modifiers.week !==undefined){
    result.setDate(7*modifiers.week);
  }
  if(modifiers.day !==undefined){
    result.setDate(modifiers.day);
  }
  if(modifiers.hour !==undefined){
    result.setHours(modifiers.hour);
  }
  if(modifiers.minute !==undefined){
    result.setMinutes(modifiers.minute);
  }
  if(modifiers.second !==undefined){
    result.setSeconds(modifiers.second);
  }
  if(modifiers.milli !==undefined){
    result.setMilliseconds(modifiers.milli);
  }
  return result;
}


export function toLocaleString(date :Date,options :Intl.DateTimeFormatOptions){
  return date.toLocaleString(i18n.getSelectedLanguage(), options)
}
/*
from Moment.js
LTS: 'h:mm:ss A',
LT: 'h:mm A',
L: 'MM/DD/YYYY',
LL: 'MMMM D, YYYY',
LLL: 'MMMM D, YYYY h:mm A',
LLLL: 'dddd, MMMM D, YYYY h:mm A',
*/

export function format(date :Date, momentString :string = 'LL', lang = i18n.getSelectedLanguage()){
  return momentString.toUpperCase().split(' ').map(subFormat=>{
    switch(subFormat){
      case 'YYYY':return date.toLocaleString(lang,  {year:"numeric"})
      case 'MMMM':return date.toLocaleString(lang,  {month:'long'})
      case 'D': return date.getDate()
      case 'DD': return date.getDate()
      case 'DM':{
        //date sans l'année
        return date.toLocaleString(lang,  {
          day: 'numeric',
          month: 'long',
        })
      }
      case 'DDDD': return date.toLocaleString(lang,  {weekday:'long'})
      case 'LT': return date.toLocaleString(lang,  {timeStyle:'short'})
      case 'L': return date.toLocaleString(lang,  {dateStyle:  'short' })
      case 'LL': return date.toLocaleString(lang,  {dateStyle:  'long' })
      case 'LLL':
      case 'LLLL':
        return date.toLocaleString(lang,  {dateStyle:  'full', timeStyle:'short'})
    }
  }).join(' ')
}

export function getWeekDaysRaw(lang = i18n.getSelectedLanguage()){
  var
    formatter = new Intl.DateTimeFormat(lang,{weekday:'long'});
  return ["2024-09-29T00:00:00","2024-09-30T00:00:00","2024-10-01T00:00:00","2024-10-02T00:00:00","2024-10-03T00:00:00","2024-10-04T00:00:00","2024-10-05T00:00:00"].map(
    date=>formatter.format(new Date(date))
  );
}
export function getMonthDaysRaw(lang = i18n.getSelectedLanguage()){
  var
    formatter = new Intl.DateTimeFormat(lang,{month:'long'});
  return ["2024-01-01T00:00:00","2024-02-01T00:00:00","2024-03-01T00:00:00","2024-04-01T00:00:00","2024-05-01T00:00:00","2024-06-01T00:00:00",
    "2024-07-01T00:00:00","2024-08-01T00:00:00","2024-09-01T00:00:00","2024-10-01T00:00:00","2024-11-01T00:00:00","2024-12-01T00:00:00"].map(
    date=>formatter.format(new Date(date))
  );
}

export function getWeekDays(localeFirstDayIndex = getFirstDayOfWeek()){
  var
    formatter = new Intl.DateTimeFormat(i18n.getSelectedLanguage(),{weekday:'long'}),
    days = ["2024-09-29T00:00:00","2024-09-30T00:00:00","2024-10-01T00:00:00","2024-10-02T00:00:00","2024-10-03T00:00:00","2024-10-04T00:00:00","2024-10-05T00:00:00"].map((date,index)=>{
      var name = formatter.format(new Date(date));
      return {
        index:(index===0?7:index),
        name,
        shortName:name.substring(0,3),
        key:["SU","MO","TU","WE","TH","FR","SA"][index],
        letter:name.substring(0,1).toUpperCase()
      }
    });
  //we remove the ones before and put them
  days.push(...days.splice(0,localeFirstDayIndex))
  return days;
}

export function getFirstDayOfWeek() :number{
  try{
    return new Intl.Locale(i18n.getSelectedLanguage()).getWeekInfo().firstDay
  }catch(e){
    //for firefox
    return {'en-us':0,'en':0}[i18n.getSelectedLanguage().toLowerCase()]||1
  }
}

export function isSameDay(dateOne :Date,dateTwo :Date){
  return dateOne.getDate()===dateTwo.getDate() && dateOne.getMonth()===dateTwo.getMonth() && dateOne.getFullYear()===dateTwo.getFullYear()
}
export function isToday(mom :Date){
  return isSameDay(new Date(),mom);
}

export function isTomorrow(mom :Date){
  var ref = new Date();
  ref.setDate(ref.getDate()+1)
  return isSameDay(ref,mom);
}
export function isYesterday(mom :Date){
  var ref = new Date();
  ref.setDate(ref.getDate()-1)
  return isSameDay(ref,mom);
}


export function getIsoWeekNumber(inputDate : Date) {
  let date = new Date(inputDate.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  // January 4 is always in week 1.
  let week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}

export function fromAllDay(allDayDate :Date){
  if(allDayDate.getUTCHours()!==0) throw new Error('Must be an all day date')
  if(allDayDate.getUTCMinutes()!==0) throw new Error('Must be an all day date')
  if(allDayDate.getUTCSeconds()!==0) throw new Error('Must be an all day date')
  if(allDayDate.getUTCMilliseconds()!==0) throw new Error('Must be an all day date')
  return new Date(allDayDate.toISOString().substring(0,10))
}

export function toAllDay(date :Date){
  return new Date(digit4(date.getFullYear())+'-'+digit2(date.getMonth()+1)+'-'+digit2(date.getDate())+'T00:00:00Z');
}

export function getNextBirthday(birthDate :Date, atDate = new Date()){
  var
    birthDateLocal = new Date(birthDate),
    securizeWhile=0;

  while(birthDateLocal.getTime()<atDate.getTime() && securizeWhile++<1000){
    birthDateLocal.setFullYear(birthDateLocal.getFullYear()+1)
  }
  return birthDateLocal;
}
export function getDeltaDays(birthDate :Date, atDate = new Date()){
  var
    now = new Date(atDate),
    counter = 0,
    securizeWhile=0;

  while((now.getMonth()!==birthDate.getMonth() || now.getDate()!==birthDate.getDate()) && securizeWhile++<1000){
    now.setDate(now.getDate()+1)
    counter++;
  }
  return counter;
}

/**
 * compute age at a given date
 * birthBate must be an allDay date
 */
export function computeAge(birthDate :Date, atDate = new Date()){
  birthDate = fromAllDay(birthDate);
  let
    age = atDate.getFullYear() - birthDate.getFullYear(),
    monthDiff = atDate.getMonth() - birthDate.getMonth();

  // Si le mois ou le jour n'est pas encore passé cette année, on enlève 1
  if (monthDiff < 0 || (monthDiff === 0 && atDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}